module.exports = __webpack_public_path__ + "img/json.e1ee4f81.png";